export default "__VITE_ASSET__CfgnDU6y__"